import React, { useState, useMemo, useCallback, createRef } from "react";
import { cloneDeep } from "lodash";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AG_GRID_LOCALE_ES } from "../../../shared/language";
import { RequisitionDetailLeft } from "./style";
import ImageWithCheckMark from "../../../shared/component/image-with-check-mark";
import { getUrlsEnv } from "../../../shared/backend-api";
import CopyIcon from "../../../shared/icons/copy-icon";
import { DoubleEquipment, Equipment, Truck, TruckDoubleEquipment, TruckEquipment } from "../../../shared/icons/assemble";
import { AssembleAvatar } from "../../assemble/assemble-avatar";
import moment from 'moment';

const getCellView = (key, params, props) => {
  let view = null;
  let appointment_loading_date = null;
  let appointment_unloading_date = null;
  let tags = [];
  let assembly_data = null;

  let vehicles = [];
  let equipments = [];

  switch(key) {
    case 'status':
      view = <RequisitionDetailLeft>{params.data?.status?.description || '-'}</RequisitionDetailLeft>
      break;
    case 'main_cta':
      view = <RequisitionDetailLeft><img style={{height: 25, width: 25}} alt="" className="logo" src="/images/dots.png" /></RequisitionDetailLeft>
      break;
    case 'order_status':
      view = <RequisitionDetailLeft>{params.data?.order_status?.description || '-'}</RequisitionDetailLeft>
      break;
    case 'trip_assembly':
      assembly_data = params.data?.parent?.assembly || null;

      vehicles = [];
      (Object.values(assembly_data?.vehicles || {}) || []).map( item => {
        if (item.length > 0) vehicles = vehicles.concat(item);
      })

      equipments = [];
      (Object.values(assembly_data?.equipments || {}) || []).map( item => {
        if (item.length > 0) equipments = equipments.concat(item);
      })

      view = <RequisitionDetailLeft>
        {
            assembly_data && (
              vehicles.length
                ? equipments.length
                  ? vehicles.length > 1
                    ? <TruckDoubleEquipment />
                    : <TruckEquipment />
                  : <Truck />
                : equipments.length
                  ? equipments.length > 1
                    ? <DoubleEquipment />
                    : <Equipment />
                  : <></>)
          }
          {"   "}
          {
            assembly_data
            && (vehicles.length
              ? (
                <div style={{marginLeft: 8}}>{
                  (vehicles || [])
                    .flat()
                    .map((e) => e.economic_number)
                }</div>
              )
              : "-")
          }
      </RequisitionDetailLeft>
      break;
    case 'order_tags':
      tags = params.data?.tags || [];
      view = <RequisitionDetailLeft>
        {
          (tags || []).map( tag => {
            return(
              <div
                key={`tag-${tag.id}`}
                style={{
                  backgroundColor: tag.color,
                  display: 'flex',
                  height: 25,
                  justifyContent: 'center',
                  alignItems: 'center',
                  paddingLeft: 4,
                  paddingRight: 4,
                  color: 'white',
                  fontSize: 11,
                  borderRadius: 8,
                  marginRight: 8
                }}
              >
                {tag.title}
              </div>
            );
          })
        }
      </RequisitionDetailLeft>
      break;
    case 'container_status':
      view = <RequisitionDetailLeft>
        {
          (params.data.container_status || []).map( item => {
            return(
              <div key={`container-status-${item.id}`}>{item.description}</div>
            );
          })
        }
      </RequisitionDetailLeft>
      break;
    case 'cta_destino': 
      appointment_unloading_date = params.data?.appointment_unloading_date || null;
      
      if (appointment_unloading_date === null) {
        view = <RequisitionDetailLeft>
          <img
            alt=""
            src="/images/edit.png"
            style={{ cursor: "pointer", marginLeft: 10, width: 21, height: 21 }}
            onClick={() => {
              props.handleChange({
                target: {
                  name: "modify-appointment-unloading",
                  value: 'Funcion de nueva cita de descarga'
                }
              });
            }}
          />
          {'Pendiente'}
        </RequisitionDetailLeft>
      } else {
        view = <RequisitionDetailLeft><img style={{height: 25, width: 25}} alt="" className="logo" src="/images/dots.png" /></RequisitionDetailLeft>
      }

      break;
    case 'unloading_date':
      appointment_unloading_date = params.data?.appointment_unloading_date || null;
      view = <RequisitionDetailLeft>
        {
          appointment_unloading_date ? 
            <>
              <div>{moment(appointment_unloading_date).format('DD/MM/YYYY HH:mm')}</div> 
              <img
                alt=""
                src="/images/edit.png"
                style={{ cursor: "pointer", marginLeft: 10, width: 21, height: 21 }}
                onClick={() => {
                  props.handleChange({
                    target: {
                      name: "modify-appointment-loading",
                      value: 'Funcion de nueva cita de carga'
                    }
                  });
                }}
              />
              <img
                alt=""
                src="/images/bin.png"
                style={{ cursor: "pointer", marginLeft: 10}}
                onClick={() => {

                }}
              />
            </>
          : 
            <>
              <img
                alt=""
                src="/images/edit.png"
                style={{ cursor: "pointer", marginLeft: 10, width: 21, height: 21 }}
                onClick={() => {
                  props.handleChange({
                    target: {
                      name: "modify-appointment-unloading",
                      value: 'Funcion de nueva cita de descarga'
                    }
                  });
                }}
              />
              {'Pendiente'}
            </>
        }
      </RequisitionDetailLeft>
      break;
    case 'to_facility':
      let logo_to_facility = params.data?.to_company || null;
      view = <RequisitionDetailLeft>
        <ImageWithCheckMark
          src={getUrlsEnv().files.concat(logo_to_facility?.logo?.substring(1) || '')}
          width={30}
          isCheckMark={logo_to_facility?.verification_status === 3}
          customStyle={{
            width: 30, height: 30, borderRadius: '50%', position: 'relative'
          }}
          type={logo_to_facility?.type_id || 0}
        />

        <div style={{marginLeft: 8}}>{params.data?.to_facility?.name || ''}</div>
      </RequisitionDetailLeft>
      break;
    case 'cta_origen':
      appointment_loading_date = params.data?.appointment_loading_date || null;
      
      if (appointment_loading_date === null) {
        view = <RequisitionDetailLeft>
          <img
            alt=""
            src="/images/edit.png"
            style={{ cursor: "pointer", marginLeft: 10, width: 21, height: 21 }}
            onClick={() => {
              props.handleChange({
                target: {
                  name: "modify-appointment-loading",
                  value: 'Funcion de nueva cita de carga'
                }
              });
            }}
          />
          {'Pendiente'}
        </RequisitionDetailLeft>
      } else {
        view = <RequisitionDetailLeft><img style={{height: 25, width: 25}} alt="" className="logo" src="/images/dots.png" /></RequisitionDetailLeft>
      }

      break;
    case 'loading_date':
      appointment_loading_date = params.data?.appointment_loading_date || null;
      view = <RequisitionDetailLeft>
        {
          appointment_loading_date ? 
          <>
            <div>{moment(appointment_loading_date).format('DD/MM/YYYY HH:mm')}</div>
            <img
              alt=""
              src="/images/edit.png"
              style={{ cursor: "pointer", marginLeft: 10, width: 21, height: 21 }}
              onClick={() => {
                props.handleChange({
                  target: {
                    name: "modify-appointment-loading",
                    value: 'Funcion de nueva cita de carga'
                  }
                });
              }}
            />
            <img
              alt=""
              src="/images/bin.png"
              style={{ cursor: "pointer", marginLeft: 10}}
              onClick={() => {

              }}
            />
          </>

            : 
          <>
            <img
              alt=""
              src="/images/edit.png"
              style={{ cursor: "pointer", marginLeft: 10, width: 21, height: 21 }}
              onClick={() => {
                props.handleChange({
                  target: {
                    name: "modify-appointment-loading",
                    value: 'Funcion de nueva cita de carga'
                  }
                });
              }}
            />
            {'Pendiente'}
          </>
        }
      </RequisitionDetailLeft>
      break;
    case 'from_facility':
      let logo_from_facility = params.data?.from_company || null;

      view = <RequisitionDetailLeft>
        <ImageWithCheckMark
          src={getUrlsEnv().files.concat(logo_from_facility?.logo?.substring(1) || '')}
          width={30}
          isCheckMark={logo_from_facility?.verification_status === 3}
          customStyle={{
            width: 30, height: 30, borderRadius: '50%', position: 'relative'
          }}
          type={logo_from_facility?.type_id || 0}
        />

        <div style={{marginLeft: 8}}>{params.data?.from_facility?.name || ''}</div>
      </RequisitionDetailLeft>
      break;
    case 'code':
      view = <RequisitionDetailLeft>
        <div className="description-action" onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();

          props.handleChange({
            target: {
              name: "trip_order_selected",
              value: {
                order_code: params.data.code,
                trip_id: params.data.parent.trip_id,
              }
            }
          });
        }}>
          {`${params.data.code || ''}`}
        </div>
        <CopyIcon className="copy-icon-style" fill={"#000000"} height="16px" width="16px" onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          
          navigator.clipboard.writeText(params.data.code); 
        }}/>
      </RequisitionDetailLeft>
      break;
    case 'secondary_actions':
      view = <RequisitionDetailLeft><img style={{height: 25, width: 25}} alt="" className="logo" src="/images/dots.png" /></RequisitionDetailLeft>
      break;
    case 'cta':
      view = <RequisitionDetailLeft></RequisitionDetailLeft>
      break;
    case 'transport_class':
      view = <RequisitionDetailLeft>
        {params.data?.transport_class?.code || '-'}
      </RequisitionDetailLeft>
      break;
    case 'assembly':
      assembly_data = params.data?.assembly || null;

      vehicles = [];
      (Object.values(assembly_data?.vehicles || {}) || []).map( item => {
        if (item.length > 0) vehicles = vehicles.concat(item);
      })

      equipments = [];
      (Object.values(assembly_data?.equipments || {}) || []).map( item => {
        if (item.length > 0) equipments = equipments.concat(item);
      })

      view = <RequisitionDetailLeft>
        {
            assembly_data && (
              vehicles.length
                ? equipments.length
                  ? vehicles.length > 1
                    ? <TruckDoubleEquipment />
                    : <TruckEquipment />
                  : <Truck />
                : equipments.length
                  ? equipments.length > 1
                    ? <DoubleEquipment />
                    : <Equipment />
                  : <></>)
          }
          {"   "}
          {
            assembly_data
            && (vehicles.length
              ? (
                <div style={{marginLeft: 8}}>{
                  (vehicles || [])
                    .flat()
                    .map((e) => e.economic_number)
                }</div>
              )
              : "-")
          }
      </RequisitionDetailLeft>
      break;
    case 'tags':
      tags = params.data?.tags || [];
      view = <RequisitionDetailLeft>
        {
          (tags || []).map( tag => {
            return(
              <div
                key={`tag-${tag.id}`}
                style={{
                  backgroundColor: tag.color,
                  display: 'flex',
                  height: 25,
                  justifyContent: 'center',
                  alignItems: 'center',
                  paddingLeft: 4,
                  paddingRight: 4,
                  color: 'white',
                  fontSize: 11,
                  borderRadius: 8,
                  marginRight: 8
                }}
              >
                {tag.title}
              </div>
            );
          })
        }
      </RequisitionDetailLeft>
      break;
    case 'fleet_provider_name':
      let logo_provider = params.data?.fleet_provider || null;
      view = <RequisitionDetailLeft>
        <ImageWithCheckMark
          src={getUrlsEnv().files.concat(logo_provider?.logo || '')}
          width={30}
          isCheckMark={logo_provider?.verification_status === 3}
          customStyle={{
            width: 30, height: 30, borderRadius: '50%', position: 'relative'
          }}
          type={logo_provider?.type || 0}
          no_image={logo_provider === null}
        />

        <div>{params.data?.fleet_provider_name || ''}</div>
      </RequisitionDetailLeft>
      break;
    case 'signature':
      view = <RequisitionDetailLeft>
        <div className="description-action" onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();

          props.handleChange({
            target: {
              name: "trip_selected",
              value: params.data
            }
          });
        }}>
          {`${params.data.signature || ''}`}
        </div>
        <CopyIcon className="copy-icon-style" fill={"#000000"} height="16px" width="16px" onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          
          navigator.clipboard.writeText(params.data.signature); 
        }}/>
      </RequisitionDetailLeft>
      break;
    default:
      view = <div/>;
  }

  return view;
}

const getValueGetter = (key, params) => {

  let value = '';

  switch(key) {
    case 'transport_class':
      value = params.data?.transport_class?.code || '';
      break;
    case 'tags':
      value = (params.data?.tags || []).map(item => item.title).join(',')
      break;
    case 'assembly':
      let assembly_data = params.data?.assembly || null;

      let vehicles = [];
      (Object.values(assembly_data?.vehicles || {}) || []).map( item => {
        if (item.length > 0) vehicles = vehicles.concat(item);
      })

      value = (assembly_data && vehicles.length) ? `${(vehicles || []).flat().map((e) => e.economic_number)}` : '';
      break;
    default:
      value = '';
  }

  return value;

}

const getCorrectName = (field, default_columns) => {
  let column = default_columns.filter( item => item.field === field);
  return (column && column.length > 0) ? column[0].headerName : null;
}

const filterParamsStatusListFormatter = params => {
  let r = params.value;
  let new_value = '';

  if (r === null) return '';

  if (['status'].includes(params.column.colId)) {
    if (Array.isArray(r)) {
      if (r.length > 0) {
        new_value = (typeof r[0] === "object") ? r[0].description : r;
      }
    } else {
      new_value = (typeof r === "object") ? r.description : r;
    }
  }

  return new_value;
}

const filterParamsStatusList = {
  valueFormatter: filterParamsStatusListFormatter
}

const getColumnsWithCustomCells = (columns, default_columns, props) => {

  columns.map( (item, index) => {

    let new_header_name = getCorrectName(item.field, default_columns);
    if (new_header_name !== null) {
      columns[index].headerName = new_header_name;
    }

    if (['fleet_provider_name', 'signature', 'transport_class', 'tags', 'status', 'assembly', 'cta', 'secondary_actions'].includes(item.field)) {
      columns[index].cellRenderer = params => {
        return getCellView(item.field, params, props)
      }
    }

    if (['status'].includes(item.field)) {
      columns[index].filterParams = filterParamsStatusList;
      columns[index].filter = "agSetColumnFilter";
      columns[index].valueFormatter = filterParamsStatusListFormatter;
    }

    if (['transport_class', 'tags', 'assembly'].includes(item.field)) {
      columns[index].valueGetter = params => {
        return getValueGetter(item.field, params);
      }
    }

  });

  return columns;
}

const applyNewColumns = (temp_colDefs, props) => {

  if (props.configuration['columns'] !== undefined && typeof props.configuration['columns'] === "object") {

    let temp_columns = props.configuration['columns'];

    if (temp_columns.length === temp_colDefs.length) {
      return getColumnsWithCustomCells(temp_columns, temp_colDefs, props);
    }

    try {

      let currentColumns = temp_colDefs.map( item => item.field);
      let currentColumnsSaved = props.configuration['columns'].map( item => item.field);
      let difference = currentColumns.filter(x => !currentColumnsSaved.includes(x));

      let newColumnsToAdd = [];

      temp_colDefs.map( (item, index) => {
        if (difference.includes(item.field)) {
          newColumnsToAdd.push({
            index,
            column: item
          })
        }
      });

      newColumnsToAdd.map( item => {
        temp_columns.splice(item.index, 0, item.column);
      });

      return getColumnsWithCustomCells(temp_columns, temp_colDefs, props);

    } catch (error) {
      console.error('Error setting columns definitions', error);

      return getColumnsWithCustomCells(temp_columns, temp_colDefs, props);
    }
  }
}

export const TripTableView = (props) => {

  const gridRef = createRef();
  const [rowData, setRowData] = useState(props.rowData);
  const [called, setCalled] = useState(false);

  let default_columns = [ 
    { headerName: '', field: 'trip_id_checkbox', suppressMenu: true,  minWidth: 80, width: 80, sortable: true, cellRenderer: "agGroupCellRenderer", headerCheckboxSelection: true, checkboxSelection: true },
    { headerName: 'Viaje Id', field: 'trip_id', suppressMenu: true, filter: 'agTextColumnFilter', minWidth: 200, sortable: true },
    { headerName: 'Transportista', field: 'fleet_provider_name', minWidth: 60, suppressMenu: true, sortable: true, filter: 'agTextColumnFilter',
      cellRenderer: params => {
        return getCellView('fleet_provider_name', params, props)
      }
    },
    { headerName: 'Número de Embarque', field: 'signature', suppressMenu: true, filter: 'agTextColumnFilter', minWidth: 200, sortable: true,
      cellRenderer: params => {
        return getCellView('signature', params, props)
      }
    },
    { headerName: 'Órdenes', field: 'orders_count', suppressMenu: true, filter: 'agTextColumnFilter', minWidth: 200, sortable: true },
    { headerName: 'Clase', field: 'transport_class', suppressMenu: true, filter: 'agTextColumnFilter', minWidth: 200, sortable: true,
      valueGetter: (params) => {
        return getValueGetter('transport_class', params);
      },
      cellRenderer: params => {
        return getCellView('transport_class', params, props)
      }
    },
    { headerName: 'Etiquetas de Viaje', field: 'tags', suppressMenu: true, filter: 'agTextColumnFilter', minWidth: 200, sortable: true,
      valueGetter: (params) => {
        return getValueGetter('tags', params);
      },
      cellRenderer: params => {
        return getCellView('tags', params, props)
      }
    },
    { headerName: 'Estatus', field: 'status', suppressMenu: true, minWidth: 200, sortable: true, filterParams: filterParamsStatusList, filter: "agSetColumnFilter", valueFormatter: filterParamsStatusListFormatter,
      cellRenderer: params => {
        return getCellView('status', params, props)
      }
    },
    { headerName: 'Ensamble', field: 'assembly', suppressMenu: true, filter: 'agTextColumnFilter', minWidth: 200, sortable: true, tooltipField: 'assembly',
      valueGetter: (params) => {
        return getValueGetter('assembly', params);
      },
      cellRenderer: params => {
        return getCellView('assembly', params, props)
      }
    },
    { headerName: 'CTA', field: 'cta', minWidth: 200, suppressMenu: true,
      cellRenderer: params => {
        return getCellView('cta', params, props)
      }
    },
    { headerName: 'Acciones Secundarias', field: 'secondary_actions', minWidth: 200, suppressMenu: true, tooltipField: 'trip_id',
      cellRenderer: params => {
        return getCellView('secondary_actions', params, props)
      }
    }
  ];

  let new_def = applyNewColumns(cloneDeep(default_columns), props);
      
  if (new_def && new_def.length > 0) {
    default_columns = new_def;
  }

  const [colDefs, setColDefs] = useState(default_columns);

  const defaultColDef = useMemo(() => {
    return {
      resizable: true,
      floatingFilter: true,
      tooltipComponent: params => {

        let columnId = params.column?.colId || '';
        let view = null;

        let vehicles = [];
        let equipments = [];
        let operators = [];

        switch(columnId) {
          case 'secondary_actions':
            view = <div
              style={{
                backgroundColor: 'black',
                color: 'white',
                padding: 10,
                borderRadius: 10
              }}
            >
              {
                params.data.fleet_provider === null &&
                <>
                  <div
                    style={{cursor: 'pointer'}}
                    onClick={() => {
                      props.handleChange({
                        target: {
                          name: "book-trip",
                          value: params.data
                        }
                      })
                    }}
                  >{'Reservar'}</div>
                  <div style={{height: 8}}/> 
                </>
              }
              <div
                style={{cursor: 'pointer'}}
                onClick={() => {
                  props.handleChange({
                    target: {
                      name: "cancel-trip",
                      value: 'Función de cancelar viaje'
                    }
                  })
                }}
              >{'Cancelar Viaje'}</div>
              <div style={{height: 8}}/>
              <div
                style={{cursor: 'pointer'}}
                onClick={() => {
                  props.handleChange({
                    target: {
                      name: "finalize-trip",
                      value: 'Función de finalizar viaje sin datos'
                    }
                  })
                }}
              >{'Finalizar Viaje Sin Datos'}</div>
              <div style={{height: 8}}/>
              <div
                style={{cursor: 'pointer'}}
                onClick={() => {
                  props.handleChange({
                    target: {
                      name: "cancel",
                      value: 'Función de cancelar resrvacion'
                    }
                  })
                }}
              >{'Cancelar Reservación'}</div>
            </div>
            break;
          case 'assembly':
            let assembly_data = params.data?.assembly || null;

            vehicles = [];
            (Object.values(assembly_data?.vehicles || {}) || []).map( item => {
              if (item.length > 0) vehicles = vehicles.concat(item);
            })

            equipments = [];
            (Object.values(assembly_data?.equipments || {}) || []).map( item => {
              if (item.length > 0) equipments = equipments.concat(item);
            })

            operators = [];
            (Object.values(assembly_data?.operators || {}) || []).map( item => {
              if (item.length > 0) operators = operators.concat(item);
            })

            if (vehicles.length > 0 || equipments.length > 0 || operators.length > 0) {

              view = <div
                style={{
                  backgroundColor: 'black',
                  color: 'white',
                  padding: 10,
                  borderRadius: 10
                }}
              >
                {
                  vehicles.map((e, i) => (
                    <div key={`vehicle-id-${i}`}>
                      <AssembleAvatar
                        fleetTypeId={1}
                        description={`${e.economic_number || ""} - ${e.plates || ""}`}
                        showIcon={true}
                      />
                    </div>
                  ))
                }
                {
                  equipments.map((e, i) => (
                    <div key={`equipment-id-${i}`}>
                      <AssembleAvatar
                        fleetTypeId={2}
                        description={`${e.economic_number || ""} - ${e.plates || ""}`}
                        showIcon={true}
                      />
                    </div>
                  ))
                }
                {
                  operators.map((e, i) => (
                    <div key={`operator-id-${i}`}>
                      <AssembleAvatar
                        fleetTypeId={3}
                        description={`${e.first_name || ""} ${e.last_name || ""}`}
                        showIcon={true}
                      />
                    </div>
                  ))
                }
              </div>
            }
            break;
          default:
            view = <div/>
        }

        return view;
      }
    };
  }, []);

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 200,
      pinned: "left",
    };
  }, []);
  
  const updateAggridConf = (params) => {
    if (called) {
      let config = {
        columns: params.api.getColumnDefs(),
        filter: params.api.getFilterModel()
      };
  
      if (props.setNewFilter) {
        props.setNewFilter(config);
      }
    }
  };

  const onGridReady = useCallback((params) => {

    if (props.allSelected) {
      params.api.selectAll()
    }

    setCalled(true);
    
  }, []);

  const detailCellRendererParams = useMemo(() => {
    return {
      detailGridOptions: {
        rowHeight: 50,
        popupParent: document.body,
        columnDefs: [
          //{ headerName: 'Orden Id', field: "order_id", suppressMenu: true, headerCheckboxSelection: true, checkboxSelection: true },
          { headerName: 'Orden', field: 'code', suppressMenu: true, minWidth: 200, sortable: true,
            cellRenderer: params => {
              return getCellView('code', params, props)
            }
          },
          { headerName: 'Origen', field: 'from_facility', suppressMenu: true, minWidth: 200, sortable: true,
            cellRenderer: params => {
              return getCellView('from_facility', params, props)
            }
          },
          { headerName: 'Cita Origen', field: 'loading_date', suppressMenu: true, minWidth: 200, sortable: true, tooltipField: 'order_id',
            cellRenderer: params => {
              return getCellView('loading_date', params, props)
            }
          },
          // { headerName: 'CTA', field: 'cta_origen', minWidth: 200, suppressMenu: true, tooltipField: 'order_id',
          //   cellRenderer: params => {
          //     return getCellView('cta_origen', params, props)
          //   }
          // },
          { headerName: 'Destino', field: 'to_facility', suppressMenu: true, minWidth: 200, sortable: true,
            cellRenderer: params => {
              return getCellView('to_facility', params, props)
            }
          },
          { headerName: 'Cita Destino', field: 'unloading_date', suppressMenu: true, minWidth: 200, sortable: true, tooltipField: 'order_id',
            cellRenderer: params => {
              return getCellView('unloading_date', params, props)
            }
          },
          // { headerName: 'CTA', field: 'cta_destino', minWidth: 200, suppressMenu: true, tooltipField: 'order_id',
          //   cellRenderer: params => {
          //     return getCellView('cta_destino', params, props)
          //   }
          // },
          { headerName: 'Estatus de Remolque', field: 'container_status', minWidth: 200, suppressMenu: true,
            cellRenderer: params => {
              return getCellView('container_status', params, props)
            }
          },
          { headerName: 'Etiquetas de Orden', field: 'order_tags', minWidth: 200, suppressMenu: true,
            cellRenderer: params => {
              return getCellView('order_tags', params, props)
            }
          },
          { headerName: 'Ensamble', field: 'trip_assembly', suppressMenu: true, minWidth: 200, sortable: true, tooltipField: 'order_id',
            cellRenderer: params => {
              return getCellView('trip_assembly', params, props)
            }
          },
          { headerName: 'Estatus de Orden', field: 'order_status', minWidth: 200, suppressMenu: true,
            cellRenderer: params => {
              return getCellView('order_status', params, props)
            }
          },
          { headerName: 'CTA', field: 'main_cta', minWidth: 200, suppressMenu: true, tooltipField: 'order_id',
            cellRenderer: params => {
              return getCellView('main_cta', params, props)
            }
          }
        ],
        rowSelection: 'multiple',
        defaultColDef: {
          flex: 1,
          tooltipComponent: params => {

            let columnId = params.column?.colId || '';
            let view = null;

            let appointment_loading_date = null;
            let appointment_unloading_date = null;

            let vehicles = [];
            let equipments = [];
            let operators = [];

            let eta = '';
            let ata = '';
            let time_to_validate = '';
            let title_value_to_show = '';
            let is_red_color = false;

            switch(columnId) {
              case 'main_cta':
                view = <div
                  style={{
                    backgroundColor: 'black',
                    color: 'white',
                    padding: 10,
                    borderRadius: 10
                  }}
                >
                  <div
                    style={{cursor: 'pointer'}}
                    onClick={() => {
                      props.handleChange({
                        target: {
                          name: "cancel-order",
                          value: 'Función de cancelar cita'
                        }
                      })
                    }}
                  >{'Cancelar Orden'}</div>
                  <div style={{height: 8}}/>
                  <div
                    style={{cursor: 'pointer'}}
                    onClick={() => {
                      props.handleChange({
                        target: {
                          name: "finalize-order",
                          value: 'Función de cambiar cita'
                        }
                      })
                    }}
                  >{'Finalizar Sin Datos'}</div>
                </div>
                break;
              case 'trip_assembly':
                let assembly_data = params.data?.parent?.assembly || null;

                vehicles = [];
                (Object.values(assembly_data?.vehicles || {}) || []).map( item => {
                  if (item.length > 0) vehicles = vehicles.concat(item);
                })

                equipments = [];
                (Object.values(assembly_data?.equipments || {}) || []).map( item => {
                  if (item.length > 0) equipments = equipments.concat(item);
                })

                operators = [];
                (Object.values(assembly_data?.operators || {}) || []).map( item => {
                  if (item.length > 0) operators = operators.concat(item);
                })

                if (vehicles.length > 0 || equipments.length > 0 || operators.length > 0) {

                  view = <div
                    style={{
                      backgroundColor: 'black',
                      color: 'white',
                      padding: 10,
                      borderRadius: 10
                    }}
                  >
                    {
                      vehicles.map((e, i) => (
                        <div key={`vehicle-id-${i}`}>
                          <AssembleAvatar
                            fleetTypeId={1}
                            description={`${e.economic_number || ""} - ${e.plates || ""}`}
                            showIcon={true}
                          />
                        </div>
                      ))
                    }
                    {
                      equipments.map((e, i) => (
                        <div key={`equipment-id-${i}`}>
                          <AssembleAvatar
                            fleetTypeId={2}
                            description={`${e.economic_number || ""} - ${e.plates || ""}`}
                            showIcon={true}
                          />
                        </div>
                      ))
                    }
                    {
                      operators.map((e, i) => (
                        <div key={`operator-id-${i}`}>
                          <AssembleAvatar
                            fleetTypeId={3}
                            description={`${e.first_name || ""} ${e.last_name || ""}`}
                            showIcon={true}
                          />
                        </div>
                      ))
                    }
                  </div>
                }
                break;
              case 'cta_destino':
                appointment_unloading_date = params.data?.appointment_unloading_date || null;
                if (appointment_unloading_date === null) return <div/>;

                view = <div
                  style={{
                    backgroundColor: 'black',
                    color: 'white',
                    padding: 10,
                    borderRadius: 10
                  }}
                >
                  <div
                    style={{cursor: 'pointer'}}
                    onClick={() => {
                      props.handleChange({
                        target: {
                          name: "cancel-unloading-date",
                          value: 'Función de cancelar cita'
                        }
                      })
                    }}
                  >{'Cancelar Cita'}</div>
                  <div style={{height: 8}}/>
                  <div
                    style={{cursor: 'pointer'}}
                    onClick={() => {
                      props.handleChange({
                        target: {
                          name: "modify-unloading-date",
                          value: 'Función de cambiar cita'
                        }
                      })
                    }}
                  >{'Cambiar Cita'}</div>
                </div>
                break;
              case 'cta_origen':

                appointment_loading_date = params.data?.appointment_loading_date || null;
                if (appointment_loading_date === null) return <div/>;

                view = <div
                  style={{
                    backgroundColor: 'black',
                    color: 'white',
                    padding: 10,
                    borderRadius: 10
                  }}
                >
                  <div
                    style={{cursor: 'pointer'}}
                    onClick={() => {
                      props.handleChange({
                        target: {
                          name: "cancel-loading-date",
                          value: 'Función de cancelar cita'
                        }
                      })
                    }}
                  >{'Cancelar Cita'}</div>
                  <div style={{height: 8}}/>
                  <div
                    style={{cursor: 'pointer'}}
                    onClick={() => {
                      props.handleChange({
                        target: {
                          name: "modify-loading-date",
                          value: 'Función de cambiar cita'
                        }
                      })
                    }}
                  >{'Cambiar Cita'}</div>
                </div>
                break;
              case 'loading_date':

                eta = params.data?.eta_loading_date || '';
                ata = params.data?.ata_loading_date || '';

                title_value_to_show = ata !== '' ? 'ATA' : eta !== '' ? 'ETA' : '';
                time_to_validate = ata !== '' ? ata : eta !== '' ? eta : '';

                if (time_to_validate === '') {

                  view = <div
                    style={{
                      backgroundColor: 'black',
                      color: 'white',
                      padding: 10,
                      borderRadius: 10
                    }}
                  >{'ETA: No disponible'}</div>

                } else {

                  if ((params.data?.appointment_loading_date || '') !== '') {
                    is_red_color = moment(time_to_validate).isSameOrAfter(params.data?.appointment_loading_date || '');
                  }

                  view = <div
                    style={{
                      backgroundColor: 'black',
                      color: 'white',
                      padding: 10,
                      borderRadius: 10,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    {
                      `${title_value_to_show}:` 
                    }
                    <div style={{color: is_red_color ? 'red' : 'white', marginLeft: 3}}>
                      {`${moment(time_to_validate).format("DD MMMM HH:mm")} hr`}
                    </div> 
                  </div>

                }

                break;
              case 'unloading_date':
                eta = params.data?.eta_unload_date || '';
                ata = params.data?.ata_unload_date || '';

                title_value_to_show = ata !== '' ? 'ATA' : eta !== '' ? 'ETA' : '';
                time_to_validate = ata !== '' ? ata : eta !== '' ? eta : '';

                if (time_to_validate === '') {

                  view = <div
                    style={{
                      backgroundColor: 'black',
                      color: 'white',
                      padding: 10,
                      borderRadius: 10
                    }}
                  >{'ETA: No disponible'}</div>

                } else {

                  if ((params.data?.appointment_unloading_date || '') !== '') {
                    is_red_color = moment(time_to_validate).isSameOrAfter(params.data?.appointment_unloading_date || '');
                  }

                  view = <div
                    style={{
                      backgroundColor: 'black',
                      color: 'white',
                      padding: 10,
                      borderRadius: 10,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    {
                      `${title_value_to_show}:` 
                    }
                    <div style={{color: is_red_color ? 'red' : 'white', marginLeft: 3}}>
                      {`${moment(time_to_validate).format("DD MMMM HH:mm")} hr`}
                    </div> 
                  </div>

                }  

                break;
              default:
                view = <div/>
            }

            return view
          }
        },
        suppressRowClickSelection: true,
        tooltipShowDelay: 500,
        tooltipInteraction: true,
        onGridReady: params => {
          if (props.allSelected) {
            params.api.forEachNode( node => {
              node.setSelected(true);
            });
          }
        },
        onSelectionChanged: params => {
          props.handleChange({
            target: {
              name: "orders_selected",
              value: (params?.api?.getSelectedRows() || []).map( item => item.order_id)
            }
          });
        }
      },
      getDetailRowData: (params) => {
        let orders = params.data.orders;

        orders = orders.map( item => {
          return {
            ...item,
            parent: params.data
          }
        })

        params.successCallback(orders);
      },
    };
  }, []);

  const getRowHeight = useCallback((params) => {
      const isDetailRow = params.node.detail;
      // for all rows that are not detail rows, return nothing
      if (!isDetailRow) { return undefined; }
  
      // otherwise return height based on number of rows in detail grid
      const detailPanelHeight = ((params.data?.orders || []).length * 52) + 65;
      
      return detailPanelHeight < 54 ? 150 : detailPanelHeight;
    }, []);

  return (
    <div>
      <div
        className="ag-theme-alpine"
        style={{ height: 650, marginBottom: 50 }}
      >
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={colDefs}
          enableCellTextSelection={true}
          suppressRowClickSelection={true}
          detailCellRendererParams={detailCellRendererParams}
          masterDetail={true}
          rowHeight={50}
          getRowHeight={getRowHeight}
          rowSelection="multiple"
          localeText={AG_GRID_LOCALE_ES}
          defaultColDef={defaultColDef}
          tooltipShowDelay={500}
          tooltipInteraction={true}
          keepDetailRows={true}
          onGridReady={onGridReady}
          onCellClicked={ params => {

            if (props.isModeSelection || (params.column?.colId || '') === 'signature') return;

          }}
          gridOptions={{
            sideBar: {
              toolPanels: ['columns', 'filters'],
              position: 'right',
              defaultToolPanel: '',
            },
          }}
          groupDisplayType={"groupRows"}
          rowGroupPanelShow={"always"}
          autoGroupColumnDef={autoGroupColumnDef}
          enableCharts={true}
          enableRangeSelection={true}
          onSelectionChanged ={ params => {
            props.handleChange({
              target: {
                name: "trips_selected",
                value: (gridRef?.current?.api?.getSelectedRows() || []).map( item => item.trip_id)
              }
            });
          }}
          onFilterChanged={ params => {
            updateAggridConf(params);
          }}
          onColumnMoved={ params => {
            if (params.finished) {
              updateAggridConf(params);
            }
          }}
          onColumnVisible={ params => {
            updateAggridConf(params);
          }} 
        />
      </div>
    </div>
  );

}